import { Injectable, ViewContainerRef } from '@angular/core';
import { SopoTooltipComponent } from '../../components/sopoTooltip/sopo-tooltip/sopo-tooltip.component';

@Injectable({
    providedIn: 'root'
})
export class SopoTooltipService {
    private _tooltipViewContainerRef: ViewContainerRef | undefined;

    set tooltipViewContainerRef(viewContainerRef: ViewContainerRef) {
        this._tooltipViewContainerRef = viewContainerRef;
    }

    constructor() { }

    showTooltip(message: string, element: HTMLElement): void {
        if (!this._tooltipViewContainerRef) {
            console.error('Tooltip view container not set');
            return;
        }

        const ref = this._tooltipViewContainerRef.createComponent(SopoTooltipComponent);
        ref.setInput('message', message);
        ref.setInput('element', element);
        const subscription = ref.instance.close.subscribe(() => {
            ref.destroy();
            subscription.unsubscribe();
        });
    }
}
